// extracted by mini-css-extract-plugin
export default {"SwipeLeftToClose":"bep_a bhk_bk bhk_bl bhk_bo","SwipeLeftToClose--animating":"bep_b"};